var a = "data-focus-lock", o = "data-focus-lock-disabled", O = "data-no-focus-lock", U = "data-autofocus-inside", c = "data-no-autofocus";
export {
  O as FOCUS_ALLOW,
  U as FOCUS_AUTO,
  o as FOCUS_DISABLED,
  a as FOCUS_GROUP,
  c as FOCUS_NO_AUTOFOCUS
};
